module.exports = __webpack_public_path__ + "img/small-hero-2.66f2449d.png";